import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type Row } from '@process-advisor/process-miner/api/methods/filters/setStepFilterSelectedGridData';
import { DataGrid } from '@process-advisor/process-miner/filters/steps/dataGrid';
import { stepGridColumns } from '@process-advisor/process-miner/filters/steps/stepGridColumns';
import { Event } from '@process-advisor/process-miner/api/events';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'

type Props = {
    setApplyEnabled: (value: boolean) => void;
    selectionMode: string;
};

export const StepsGrid: React.FC<Props> = ({ setApplyEnabled, selectionMode }) => {
    const [rows, setRows] = React.useState([]);
    const [columns, setColumns] = React.useState<ColDef[]>();

    React.useEffect(() => {
        setRows(apiProvider.processStepsTable());
        setColumns(stepGridColumns())
    }, []);

    React.useEffect(() => {
        const listener = () => {
            setRows(apiProvider.processStepsTable());
        }
        listener();

        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);
        apiProvider.on(Event.updateDurationColumns, listener);

        return () => {
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
            apiProvider.off(Event.updateDurationColumns, listener);
            };
    }, []);

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            setApplyEnabled={setApplyEnabled}
            selectionMode={selectionMode}
            height="300px" />
    );
};
